<template>
  <!-- Modal de Recuperar contraseña -->
  <div
    class="modal fade"
    id="forgotPasswordModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="forgotPasswordModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-t="'forgotPassword.title'"></h5>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="header-pic">
          <img src="/img/head_login.jpg" />
        </div>
        <div class="modal-body">
          <div v-if="showForgotMessage" class="forgot-message alert" :class="forgotAlertType">{{ forgotMessage }}</div>
          <form
            class="form-signin form-forgot"
            id="form-forgot"
            v-on:submit.prevent="sendForm()"
            data-vv-scope="form_forgot"
          >
            <input
              type="text"
              id="inputEmailForgot"
              name="email"
              class="form-control"
              :placeholder="$t('forgotPassword.inputs.email')"
              @keypress="withoutSpace($event)"
              @input="form_data.user = $event.target.value.toLowerCase()"
              v-validate="'required|email'"
              v-model.trim="form_data.user"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_forgot.email')"
              >{{ errors_validate.first("form_forgot.email") }}</span
            >

            <div class="col-md-12 cont-captcha">
              <!-- <vue-recaptcha
                ref="invisibleRecaptcha1"
                :sitekey="sit_ky"
                :loadRecaptchaScript="false"
                recaptchaScriptId="invisibleRecaptcha1"
                size="invisible"
                @verify="onCaptchaVerified"
                @expired="onExpired"
              ></vue-recaptcha> -->
            </div>

            <div class="bt-signin-box">
              <button
                class="material-btn bt_red"
                type="submit"
                :disabled="is_send"
                v-t="'forgotPassword.actions.forgot'"
              ></button>
            </div>
          </form>
        </div>
        <div class="cont_loader_login_form">
          <vue-loading
            type="spin"
            color="#d9544e"
            :size="{ width: '30px', height: '30px' }"
            v-show="validando_captcha"
          ></vue-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snackbar from "node-snackbar";
import { mapActions } from "vuex";
import * as auth_request from "../../request/auth.js";
import AuthMixins from "../../mixins/auth.js";

export default {
  props: {
    validateRecaptcha: {
      type: Function,
      default: () => {},
    },
    resetTheRecaptcha: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [AuthMixins],
  mounted() {
    $(document).ready(function () {
      $("#forgotPasswordModal").on("show.bs.modal", function () {
        document.getElementById("app").style.position = "relative";
      });

      $("#forgotPasswordModal").on("hidden.bs.modal", function () {
        document.getElementById("app").style.position = null;
      });
    });
  },
  data() {
    return {
      form_data: {
        user: ""
      },
      forgotMessage: "Hola",
      forgotAlertType: "alert-success",
      showForgotMessage: false,
      is_send: false,
      url_api: window.url_api,
      error_forgot: window.error_forgot ? window.error_forgot : false,
      sit_ky: process.env.VUE_APP_RECAPTH_KEY_PROD,
    };
  },

  methods: {
    ...mapActions(["changueUser", "changueToken"]),
    sendForm() {
      this.$validator.validateAll("form_login").then((result) => {
        if (result) {
          console.log({result});
          this.validateRecaptcha("forgotPassword");
          this.validando_captcha = true;
          this.is_send = true;
        } else {
          // Si el formulario no es valido
          this.is_send = false;
        }
      });
    },
    onCaptchaVerified(token) {
      this.validando_captcha = false;
      let vm = this;
      // Reinicia el Captcha
      vm.resetCaptcha();
      let data = new FormData();
      data.append("email", vm.form_data.user);
      // data.append("g-recaptcha-response", token);

      
      // envia
      auth_request
        .postForgotPassword(data)
        .then((response) => {
          vm.forgotAlertType = "alert-success"
          vm.forgotMessage = vm.$t("alert.password_reset_link")
          vm.showForgotMessage = true
          vm.form_data.user = "";
          vm.is_send = false;
          setTimeout(() => {
            vm.$validator.reset();
          }, 300);
        })
        .catch((err_) => {
          vm.is_send = false;
          vm.forgotAlertType = "alert-danger"
          if (err_.response.status === 422) {
            vm.forgotMessage = vm.$t("alert.usuario_no_existe")
          
          } else {
            vm.forgotMessage = vm.$t("alert.error_admin")
          }
          vm.showForgotMessage = true
          setTimeout(() => {
            vm.showForgotMessage = false
            vm.forgotMessage = ""
          }, 10000);
        });
    },
    withoutSpace: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 32) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetCaptcha() {
      this.resetTheRecaptcha();
    },
    onExpired() {},
  },
  created() {
    this.$validator.attach("email", "required|email");
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none !important;
}

.form-forgot .bt-signin-box {
  height: auto;
}

.form-forgot button[type="submit"] {
  width: auto;
  margin-top: 1rem;
}

.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}

.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}

.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
</style>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/forgotPassword.json" />
<i18n src="@/locale/modals/alertas.json" />
